import React, { useState } from "react";
import wardController from "../../../../apis/Controllers/WardController/ward.controller";
import hospitalController from "../../../../apis/Controllers/HospitalController/hospital.controller";
import { useNavigate } from "react-router-dom";


const AdminDashbordFunctons = () => {
    var breadcrumData = ["Dashboard"];
    var breadcrumItem = "Ward";
    const [wardList, setWardList] = useState([]);
    const [hospitalList, setHospitalList] = useState([]);
    const [dropdownValue, setDropdownValue] = useState(null);
    const [hospitalId, setHospitalId] = useState(null);
    const [loader, setLoader] = useState(false);
    let navigate = useNavigate();

    
    const getWardsList = async () => {
        if(!loader){
            let body = {
                hospital_id: hospitalId ? hospitalId : ''
            }
            setLoader(true);
            let response = await wardController.wardListing(body);
            if (response && response.status) {
                setWardList(response.data)
                setLoader(false);
            }
            else {
                setWardList([]);
                setLoader(false);
            }
            setLoader(false);
        }
    };


    const getHospitalList = async () => {
        let response = await hospitalController.hospitalListing();
        if (response && response.status) {
            setHospitalList(response.data)
        }
        else {
            setHospitalList([]);
        }
    };


    return {
        wardList,
        getWardsList,
        getHospitalList,
        hospitalList,
        setDropdownValue,
        dropdownValue,
        navigate,
        hospitalId,
        setHospitalId,
        loader, 
        setLoader,
        breadcrumData,
        breadcrumItem
    }
};

export default AdminDashbordFunctons;